(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Lazy = function () {
  function Lazy(container, text, date) {
    _classCallCheck(this, Lazy);

    this.container = container;
    this.update(text, date);
  }

  _createClass(Lazy, [{
    key: "getFormattedTime",
    value: function getFormattedTime(date) {
      return Lazy.addZero(date.getHours()) + ":" + Lazy.addZero(date.getMinutes()) + ":" + Lazy.addZero(date.getSeconds());
    }
  }, {
    key: "update",
    value: function update(text, date) {
      var _this = this;

      this.container.innerHTML = "\n      <div>\n        <div>\n          Not changed:\n          <span>\n            " + this.getFormattedTime(new Date()) + "\n          </span>\n        </div>\n        <span class=\"text\">\n          " + text + "\n        </span>\n        <span class=\"time\">\n          " + this.getFormattedTime(date) + "\n        </span>\n      </div>\n    ";
      this.update = function (text, date) {
        var textNode = _this.container.querySelector('.text');
        var timeNode = _this.container.querySelector('.time');
        textNode.innerHTML = text;
        timeNode.innerHTML = _this.getFormattedTime(date);
      };
    }
  }], [{
    key: "addZero",
    value: function addZero(time) {
      return time < 10 ? '0' + time : time;
    }
  }]);

  return Lazy;
}();

exports.default = Lazy;

},{}],2:[function(require,module,exports){
'use strict';

var _Lazy = require('./Lazy');

var _Lazy2 = _interopRequireDefault(_Lazy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var counter = 0;
var elements = ['Zero', 'First', 'Second', 'Third', 'Fourth'];

var timeout = null;
var lazy = new _Lazy2.default(document.getElementById('test'), elements[counter], new Date());

timeout = setInterval(function () {
  if (counter === 4) {
    clearInterval(timeout);
  }
  lazy.update(elements[counter++], new Date());
}, 500);

},{"./Lazy":1}]},{},[2])

